// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PoundCircleFilledSvg from "@ant-design/icons-svg/es/asn/PoundCircleFilled";
import AntdIcon from '../components/AntdIcon';

var PoundCircleFilled = function PoundCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PoundCircleFilledSvg
  }));
};

PoundCircleFilled.displayName = 'PoundCircleFilled';
export default React.forwardRef(PoundCircleFilled);